// Auto-generated translation for mt.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:46:00.124882+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Għal sidien taż-żwiemel",
    title: "Kollox għaż-żiemel tiegħek. F'app waħda.",
    subtitle: "Immaniġġja s-saħħa, it-taħriġ, il-ippjanar u l-professjonisti minn fajl wieħed ċar u organizzat.",
    primaryCTA: {
      label: "Ibda b'xejn",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ara l-Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Profil taż-żiemel — piż, tilqim, EquiCoach, ikel u taħriġ f'ekran wieħed",
      caption: "Iż-żiemel tiegħek, komplut f'daqqa.",
    },
    problem: "Fil-ħin preżenti x'aktarx qed iżżomm appuntamenti, ritratti, taħriġ, ikel u saħħa mxerrda — fi gruppi ta' WhatsApp, kaxxi tal-kartun u apps separati. Dan jagħmlek titlef il-ħarsa ġenerali.",
    solution: "EquiSight jibdel iż-żiemel tiegħek f'fajl diġitali komplet li jiġi miegħek kullimkien.",
    benefits: [
      "Profil komplet wieħed għal kull żiemel",
      "Saħħa, farrier, dentist u fisjoterapeuta f'post wieħed",
      "Aġenda b'tfakkir intelliġenti",
      "Ritratti, noti u storja mingħajr limitu",
      "Backup tad-dejta kollha tiegħek mal-Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 żiemel · dejjem b'xejn",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Żwiemel multipli + backup",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Lest tibda?",
      title: "Ibda llum biż-żiemel tiegħek l-ewwel.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Aktar żwiemel. Aktar ħarsa ġenerali. Aktar ċertezza.",
    subtitle: "Aġġorna għal Premium u ġestixxi l-ażżwiemel kollha tiegħek mingħajr limitazzjonijiet — bl-intelliġenza sħiħa ta' EquiCoach.",
    primaryCTA: {
      label: "Ibda 14-il jum b'xejn",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Il-prezzijiet kollha",
      href: "/#pricing",
    },
    audience: "Għal sidien, rikkieba sportivi u dawk li jżommu żwiemel multipli.",
    features: [
      "Żid żwiemel mingħajr limitu",
      "Storja sħiħa għal kull żiemel",
      "Backup tad-data",
      "Approfondimenti estensivi ta' EquiCoach",
      "Notifiki u ppjanar intelliġenti",
      "Saħħa u taħriġ konnessi kompletament",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Inqas minn €0,17 kuljum",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Lest?",
      title: "Aġġorna għal Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Għar-rikkieba tal-manège",
    title: "Issir aħjar, anke mingħajr żiemel tiegħek.",
    subtitle: "Segwi t-tagħlim, it-taħriġ u l-iżvilupp tiegħek ġewwa EquiSight — bi inqas mill-prezz ta' kikkra kafè fix-xahar għal papa jew mama. Jew ġelat tajjeb bil-krema.",
    primaryCTA: {
      label: "Ibda bi Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Kif jaħdem?",
      href: "#features",
    },
    problem: "Bħala rikkieb tal-manège spiss m'għandekx żiemel tiegħek stess, iżda xorta trid tikber u żżomm kontroll fuq it-tagħlim, il-miri u ż-żwiemel li tirrikeb fuqhom.",
    solution: "Il-funzjonalità tal-manège hija inkluża b'mod standard fi Premium — segwi l-iżvilupp tiegħek u ara ż-żwiemel tal-manège marbuta bħala read-only.",
    features: [
      "Żomm rekord tat-taħriġ",
      "Issettja l-miri",
      "Segwi l-progress",
      "Ara ż-żwiemel tal-manège bl-isem u r-ritratt",
      "L-ebda aċċess għad-data tas-saħħa privata",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Fix-xahar · funzjonalità tal-manège inkluża",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Issieħeb",
      title: "Ibda bħala rikkieb tal-manège.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Għal manegi u stabbli",
    title: "Agħmel il-manege tiegħek aċċessibbli diġitalment għal kull rakkeb.",
    subtitle: "Agħti lir-rakkeba rabta mal-żwiemel, it-tagħlim u l-progress — mingħajr ma taqsam data sensittiva tal-istabbli.",
    primaryCTA: {
      label: "Itlob aċċess",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ara l-moduli",
      href: "#features",
    },
    audience: "EquiSight jgħin lill-manegi u l-istabbli biex iżommu lir-rakkeba involuti għal aktar żmien u jiddistingwu ruħhom diġitalment.",
    features: [
      "Agħmel iż-żwiemel tal-manege viżibbli għar-rakkeba",
      "Isem u ritratt għal kull żiemel",
      "Qabbel ir-rakkeba maż-żwiemel",
      "Aċċess għal qari biss għal data sensittiva tal-privatezza",
      "Storja tal-lezzjonijiet u t-taħriġ f'post wieħed",
      "Ġestjoni tal-utenti b'rwoli",
    ],
    benefits: [
      "Aktar rabta mar-rakkeba",
      "Dehra aktar professjonali",
      "Servizz diġitali addizzjonali għall-membri",
      "Sors ġdid ta' dħul permezz tal-użu tal-app",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Kull xahar · funzjonalità tal-manege inkluża għar-rakkeba",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Lest?",
      title: "Attiva l-Modulu tal-Manege.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Modulu tal-Trobbija",
    title: "Kontroll fuq iċ-ċiklu, it-tqala u l-iżvilupp tal-felu.",
    subtitle: "Il-modulu komplet tal-trobbija għal sidien tal-iewwez u allevaturi — mid-dħul sad-dħla tal-felu, f'linja waħda taż-żmien.",
    primaryCTA: {
      label: "Attiva l-Modulu tal-Trobbija",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ara l-funzjonijiet",
      href: "#features",
    },
    audience: "Għal allevaturi, sidien tal-iewwez u stallijiet li jimmaniġġjaw iewwez multipli.",
    features: [
      "Traċċar taċ-ċiklu",
      "Irreġistra l-estru",
      "Irreġistra d-data tal-inseminazzjoni",
      "Countdown għall-ekoġrafiji",
      "Ippjanar tal-kontrolli tat-tqala",
      "Siġra ġenealoġika u dixxendenza",
      "Iżvilupp tal-felu",
      "Ħarsa ġenerali tal-iewwez kollha tqal",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Kull xahar · Modulu tal-Trobbija inkluż fil-Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Ibda llum",
      title: "Ibda bil-ġestjoni tal-trobbija.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Modulu tal-Ferratur",
    title: "Agħmel xogħlok b'mod aktar intelliġenti bħala ferratur. Irreġistra kollox b'mod professjonali.",
    subtitle: "Aġenda, ritratti, kummenti u storja tat-trattamenti f'modulu wieħed — inqas komunikazzjoni ħażina, fajl aktar b'saħħtu.",
    primaryCTA: {
      label: "Ibda bħala Ferratur",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ara l-Pakkett Professional",
      href: "/professional",
    },
    audience: "Għal ferratura li jridu jtejbu l-ħarsa ġenerali, id-dokumentazzjoni u l-komunikazzjoni mal-klijenti.",
    features: [
      "Aġenda personali",
      "Appuntamenti għal kull klijent",
      "Ara l-profili taż-żwiemel",
      "Żid ritratti qabel u wara",
      "Irreġistra t-trattament",
      "Irreġistra pariri u kummenti",
      "Notifika ETA lill-klijent: \"Il-ferratur qiegħed fit-triq\"",
    ],
    benefits: [
      "Taħdem b'mod aktar professjonali",
      "Inqas komunikazzjoni ħażina",
      "Bini aħjar tal-fajl",
      "Aktar b'saħħtek fil-każ ta' responsabbiltà",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Kull xahar · Modulu tal-Ferratur inkluż fil-Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Lest?",
      title: "Attiva l-Modulu tal-Ferratur.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Modulu tad-dentist taż-żwiemel",
    title: "Fajl dentali komplut għal kull żiemel.",
    subtitle: "Irreġistra s-sejbiet, it-trattamenti u s-segwitu direttament f'EquiSight.",
    primaryCTA: {
      label: "Ibda bħala dentist taż-żwiemel",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ara l-Pakkett Professional",
      href: "/professional",
    },
    audience: "Dentisti taż-żwiemel, veterinarji u prattiki li jixtiequ jaħdmu b'mod strutturat.",
    features: [
      "Irreġistra l-eżami tad-dentalità",
      "Sejbiet għal kull trattament",
      "Żid ritratti",
      "Rapport lill-proprjetarju",
      "Parir ta' segwitu",
      "Storja għal kull żiemel",
      "Ippjana appuntament ġdid",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Kull xahar · Modulu tad-dentist inkluż fil-Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Lest?",
      title: "Attiva l-Modulu tad-Dentist.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Modulu Fisjo / Osteo",
    title: "Segwi l-ġisem, il-moviment u l-irkupru b'mod professjonali.",
    subtitle: "Għall-fisjoterapeisti u l-osteopati li jridu jakkumpanjaw il-ħwejjeġ b'mod strutturali.",
    primaryCTA: {
      label: "Ibda bħala fisjo/osteo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ara l-Pakkett Professional",
      href: "/professional",
    },
    features: [
      "Intake għal kull żiemel",
      "Irreġistra s-sejbiet tal-ġisem",
      "Żid ritratti u vidjows",
      "Oħloq rapport tal-kura",
      "Aqsam l-eżerċizzji u s-segwitu",
      "Segwi t-triq tal-irkupru",
      "Storja għal kull żiemel",
    ],
    benefits: [
      "Fehim aħjar maż-żmien",
      "Rapportaġġ professjonali",
      "Komunikazzjoni ċara mas-sid, it-trainer u r-rider",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Kull xahar · Modulu Fisjo / Osteo inkluż fil-Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Lest?",
      title: "Attiva l-Modulu Fisjo / Osteo.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Modulu tat-trainer",
    title: "Ikkowtja rikkieba b'data, miri u progress.",
    subtitle: "Agħmel it-taħriġ ikejjel u l-gwida aktar professjonali — għal wieħed jew aktar rikkieba.",
    primaryCTA: {
      label: "Ibda bħala trainer",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ara l-pakkett Pro",
      href: "/#pricing",
    },
    audience: "Għal struzzuri, trainers u coaches b'aktar minn rikkiem wieħed jew żiemel wieħed.",
    features: [
      "Waħħal rikkieba",
      "Segwi żwiemel",
      "Iffissa miri tat-taħriġ",
      "Agħti feedback",
      "Analizza r-riżultati tal-kompetizzjonijiet",
      "Ara l-progress għal kull kombinazzjoni",
      "Uża analiżi tal-protokoll għall-fokus tat-taħriġ",
    ],
    benefits: [
      "Gwida aħjar",
      "Aktar struttura",
      "Komunikazzjoni aktar professjonali",
      "Rabta akbar mal-klijenti",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Kull xahar · Modulu tat-trainer inkluż fil-Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Lest?",
      title: "Attiva l-Modulu tat-Trainer.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Analiżi tal-Kompetizzjoni",
    title: "Mill-protokoll għat-titjib tal-prestazzjoni.",
    subtitle: "Itlgħa l-protokoll tal-kompetizzjoni tiegħek u skopri fejn qed titlef il-punti — mhux biss tara l-iskor tiegħek, iżda tifhem kif tista' titjieb.",
    primaryCTA: {
      label: "Analizza l-ewwel protokoll tiegħek",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ara Premium",
      href: "/premium",
    },
    features: [
      "Itlgħa ritratt tal-protokoll",
      "Ipproċessa l-quddiem u l-wara",
      "Agħraf il-klassi, in-numru tal-prova u l-imħallef",
      "Analizza l-iskorijiet għal kull sezzjoni",
      "Sommarju tal-kummenti",
      "Uri l-punti b'saħħithom u dawk dgħajfin",
      "Tendenzi għal kull kombinazzjoni ta' żiemel-kavalier",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Kull xahar · analiżi tal-kompetizzjoni inkluża mill-Premium",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Lest?",
      title: "Ibda bl-analiżi tal-kompetizzjoni.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Pakkett Professional",
    title: "Għall-professjonisti madwar iż-żiemel.",
    subtitle: "Ferriera, dentist, fisjoterapeuta, osteopat jew trainer: ħidmu flimkien f'fajl diġitali wieħed taż-żiemel.",
    primaryCTA: {
      label: "Ibda bħala professjonist",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ara l-moduli separati",
      href: "#features",
    },
    audience: "Il-Pakkett Professional jgħaqqad il-moduli kollha speċjalizzati f'abbonament wieħed.",
    features: [
      "Modulu tal-Ferriera",
      "Modulu tad-Dentist",
      "Modulu tal-Fisjoterapeuta / Osteopat",
      "Aġenda u ġestjoni tal-klijenti",
      "Profili taż-żwiemel u rapporti",
      "Storja tat-trattamenti u bini tal-fajl",
      "Komunikazzjoni mas-sid",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Kull xahar · il-moduli speċjalizzati kollha inklużi",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Lest?",
      title: "Agħżel Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Numri ta' emerġenza għaż-żiemel",
    title: "Dejjem l-għajnuna t-tajba fil-viċin.",
    subtitle: "F'emerġenza, kull sekonda tgħodd. Ma' EquiSight, għandek id-dejta tal-kuntatti importanti kollha taż-żiemel tiegħek lesta minnufih — tik wieħed u tkun qed issejjaħ.",
    primaryCTA: {
      label: "Ħejji l-kuntatti ta' emerġenza tiegħek",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ibda b'xejn ma' EquiSight",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Kuntatti ta' emerġenza — sejjaħ, ibgħat WhatsApp jew innnaviga lejn il-veterinarju, il-klinika u l-farrier direttament",
      caption: "Tik wieħed. L-ebda paniku.",
      embeddedFrame: true,
    },
    problem: "Iż-żiemel tiegħek għandu xi ħaġa — koliku, ferità, paniku. U mbagħad tibda tfittex. Lil min issejjaħ? Għandek in-numru t-tajjeb? Dan huwa n-numru ta' emerġenza? Ħin prezzjuż jintilef.",
    solution: "Ma' EquiSight, għandek kollox lest fil-pront. L-ebda tfittxija. L-ebda dubju. Tik wieħed u jkollok kuntatt.",
    scenario: {
      title: "Immaġina — iż-żiemel tiegħek qed juri sinjali ta' koliku.",
      steps: [
        "Tiftaħ EquiSight",
        "Tikklikkja fuq \"Veterinarju\"",
        "Issejjaħ direttament",
      ],
      tagline: "L-ebda stress. L-ebda tfittxija. Azzjoni biss.",
    },
    features: [
      "In-numri ta' emerġenza kollha f'post wieħed",
      "Sejħa b'tik wieħed mill-app",
      "WhatsApp b'tik wieħed",
      "Innnaviga direttament lejn l-indirizz",
      "Lista ta' kuntatti proprja għal kull żiemel",
      "Veterinarju, klinika, farrier, dentist, fisjoterapeut",
      "Indirizz + direzzjonijiet disponibbli minnufih",
      "Immarka n-numri favoriti b'stilla",
      "Numri ta' emerġenza (112, 144) dejjem fuq nett",
    ],
    benefits: [
      "Kalma u kontroll f'sitwazzjoni ta' emerġenza",
      "Kulħadd fl-istalla għandu l-istess numri lesti",
      "L-ebda karti tal-viżita minsija aktar",
      "Irrispondi sekondi aktar mgħaġġel f'każ ta' urġenza",
    ],
    audience: "Għal sidien taż-żwiemel, min jieħu ħsiebhom, it-trainers u l-istallas — kulħadd responsabbli għal żiemel.",
    showcase: {
      eyebrow: "Impostati minn qabel għalik",
      title: "13-il kategorija ta' kuntatti — lesta biex timla.",
      description: "Mill-veterinarju u l-klinika tal-emerġenza sa l-armar, l-istrutttur u l-amministratur tar-mergħa. EquiSight jaf id-dinja tiegħek u jħejjilek il-kamps tal-kuntatti t-tajbin. Tik, imla, lest.",
      bullets: [
        "Emerġenza u saħħa — veterinarju, spedizzjoni, klinika, linja tal-avvelenament",
        "Kura ta' kuljum — farrier, dentist, fisjoterapeut, istrutttur",
        "Stalla u mergħa — sid tal-istalla, amministratur tar-mergħa, stalla ta' pensjoni",
        "Ikel u materjali — fornituri ta' tiben, għalf u straw",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Skrin tal-ġestjoni tal-kuntatti ta' emerġenza — il-kuntatti kollha suġġeriti skont il-kategorija",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Ċekklist tan-numri ta' emerġenza għaż-żiemel",
      items: [
        "Veterinarju",
        "Klinika ta' emerġenza (24/7)",
        "Ambulanza tal-annimali · 144",
        "Farrier",
        "Persuna ta' kuntatt ta' riserva",
        "Numru ġenerali tal-emerġenza · 112",
      ],
      cta: {
        label: "Iftaħ f'EquiSight u imla minnufih",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Numri ta' emerġenza",
          price: "Gratis",
          note: "Dejjem b'xejn · għal kulħadd, fi kwalunkwe abbonament",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Kun lest minn qabel",
      title: "Qabel ma jkun meħtieġ.",
      href: "/#waitlist",
    },
    microcopy: [
      "L-ebda obbligu",
      "Impostata f'2 minuti",
      "Dejjem aġġustabbli",
    ],
  },
};

export default LANDINGS;
